import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconCloseSolid24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="close">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 2C0 0.89543 0.895431 0 2 0H22C23.1046 0 24 0.895431 24 2V22C24 23.1046 23.1046 24 22 24H2C0.89543 24 0 23.1046 0 22V2ZM16.9498 5.63604L18.364 7.05025L13.4142 12L18.364 16.9497L16.9497 18.364L12 13.4142L7.05027 18.364L5.63606 16.9497L10.5858 12L5.63603 7.05025L7.05024 5.63604L12 10.5858L16.9498 5.63604Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
